import clsx from 'clsx';
import React, { FC, useEffect, useState } from 'react';
import { CustomTypography } from 'src/components/custom/CustomTypography';
import {
  IClientType,
  useCreateClientTypeMutation,
  useUpdateClientTypeMutation,
} from 'src/redux/services/settings';
import { SidePanel } from '../../sidePanel/SidePanel';
import styles from './EditClientTypes.module.css';
import TextField from '@mui/material/TextField';

type TEditClientTypeTemplate = {
  isOpen: boolean;
  onClose: () => void;
  type?: IClientType;
};

export const EditClientType: FC<TEditClientTypeTemplate> = ({ isOpen, onClose, type }) => {
  const [name, setName] = useState(type?.name || '');
  const [error, setError] = useState<string | null>(null);
  const [createClientType] = useCreateClientTypeMutation();
  const [updateClientType] = useUpdateClientTypeMutation();

  const handleContentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleSave = async () => {
    if (!name) {
      setError('Введите название типа приложений');
      return;
    }

    if (type) {
      await updateClientType({ id: type.id, body: { name } }).unwrap();
    } else {
      await createClientType({ name }).unwrap();
    }
    onClose();
  };

  useEffect(() => {
    setName(type?.name || '');
  }, [type]);

  const headerText = type ? 'Редактировать тип приложений' : 'Создать тип приложений';

  return (
    <>
      <SidePanel
        onClose={onClose}
        isOpen={isOpen}
        title={headerText}
        isNoBackdrop
        handleConfirm={handleSave}
      >
        <div className={styles.wrapper}>
          <div>
            <CustomTypography className={clsx('text-14', styles.inputLabel)}>
              Название группы
            </CustomTypography>
            <TextField
              value={name}
              onChange={handleContentChange}
              error={!!error}
              helperText={error}
              className="custom"
              fullWidth
              variant="standard"
            />
            <CustomTypography color="grey" className={clsx('text-14', styles.inputDescription)}>
              Отображаемое имя типа
            </CustomTypography>
          </div>
        </div>
      </SidePanel>
    </>
  );
};
